import React, { Dispatch } from 'react'
import { Row, Col, Select, Checkbox } from "antd"
import "./detecteErrorFilter.css"
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

const { Option } = Select;

const DetectedErrorFilter = (props: { selectedDate: any, setSelectedDate: Dispatch<any>, selectedFilter: string[], setSelectedFilter: Dispatch<any> }) => {
  const { selectedDate, setSelectedDate, selectedFilter, setSelectedFilter } = props

  const handleCheckbox = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setSelectedFilter((prev: any) => [...prev, e.target.value])
    } else {
      setSelectedFilter(selectedFilter.filter((elem) => elem !== e.target.value))
    }
  }

  return (
    <Row className='error-filter'>
      <Col xs={24} className="checkbox-list">
        <div>
          <Checkbox checked={selectedFilter.find(elem => elem === 'wrong sku') ? true : false} onChange={handleCheckbox} value={"wrong sku"} defaultChecked>
            <div className='yellow-dot dot' />
            Bracelet ne correspond pas au SKU
          </Checkbox>
        </div>
        <div>
          <Checkbox checked={selectedFilter.find(elem => elem === 'wrong count') ? true : false} onChange={handleCheckbox} value={'wrong count'} defaultChecked>
            <div className='blue-dot dot' />
            Nombre de bracelets incorrect</Checkbox>
        </div>
        <div>
          <Checkbox checked={selectedFilter.find(elem => elem === 'lisibility') ? true : false} onChange={handleCheckbox} value={'lisibility'} defaultChecked>
            <div className='red-dot dot' />
            SKU illisible</Checkbox>
        </div>
        <div>
          <Checkbox checked={selectedFilter.find(elem => elem === 'other') ? true : false} onChange={handleCheckbox} value={'other'} defaultChecked>
            <div className='grey-dot dot' />
            Autre</Checkbox>
        </div>
      </Col>
    </Row>
  )
}

export default DetectedErrorFilter